function fetchLeurisProfileQuery ({ fisPersid }) {
  let variables = { fisPersid }

  return {
    operationName: 'fetchLeurisProfileQuery',
    query: `
      query fetchLeurisProfileQuery($fisPersid: ID!) {
        person(id: $fisPersid) {
          name: _stringRep
          orcid
          ulWebsiteProfileDe
          ulWebsiteProfileEn
          leurisProfile {
            abstract {
              de
              en
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchLeurisProfileQuery }



// WEBPACK FOOTER //
// ./src/graphql/leurisProfile.js